var a = {};
export {
  a as __exports
};
//# sourceMappingURL=index.es347.js.map
